import React, { useEffect, useRef, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { fetchFromStrapi } from "../api/strapi";
import { BlogDetailsSkeleton, EmptyState } from "../components/SkeletonUI";
import BlogReadAloud from "../components/BlogReadAloud";

export default function BlogDetails() {
  const { slug } = useParams();
  const [blog, setBlog] = useState(null);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const { id } = useParams();
  const bodyRef = useRef(null);

  useEffect(() => {
    async function fetchBlog() {
      try {
        const res = await fetchFromStrapi(`/ecls/${id}`);
        setBlog(res?.data?.data || res?.data);

        console.log("Fetched blog details:", res);
      } catch (err) {
        console.error("Error fetching blog:", err);
      } finally {
        setLoading(false);
      }
    }

    fetchBlog();
  }, [id]);

  const getImageUrl = item =>
    item?.attributes?.image?.data?.attributes?.url;

  if (loading) return <BlogDetailsSkeleton />;

  if (!blog) return (
    <div className="container">
      <EmptyState
        title="Post not found"
        description="This article may have been moved or removed. Head back to explore other posts."
        action={{ label: "Browse all posts", href: "/blog" }}
      />
    </div>
  );

  const { title, content, serviceType, publishedAt } = blog.attributes;

  return (
    <>
      {/* HERO IMAGE */}
      <div
        style={{
          maxWidth: 820,
          width: "100%",
          position: "relative",
          margin: "0 auto 20px",
        }}
      >
        <button
          className="btn btn-outline-dark"
          onClick={() => navigate(-1)}
        >
          Back
        </button>
      </div>

      <div>
         <section
            style={{
              height: "64vh",
              maxWidth: 820,
              width: "100%",
              position: "relative",
              borderRadius: 8,
              margin: "0 auto 20px",
              backgroundImage: `url(${getImageUrl(blog)})`,
              backgroundSize: "cover",
              backgroundPosition: "top center",
            }}
          />
      </div>

      {/* CONTENT */}
      <section className="container py-5">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <small className="text-uppercase text-muted">
              {serviceType}
            </small>

            <h1 className="fw-bold display-6 mt-2 mb-3">
              {title}
            </h1>

            <small className="text-muted">
              {new Date(publishedAt).toDateString()}
            </small>

            <hr className="my-4" />

            {/* BODY */}
            <div
              ref={bodyRef}
              className="blog-content"
              style={{ lineHeight: 1.8, fontSize: 17, paddingBottom: '120px' }}
              dangerouslySetInnerHTML={{ __html: content }}
            />
          </div>
        </div>
      </section>

      <BlogReadAloud title={title} bodyRef={bodyRef} />
    </>
  );
}
